import { render, staticRenderFns } from "./UserEditMasterStatus.vue?vue&type=template&id=651323c6"
import script from "./UserEditMasterStatus.vue?vue&type=script&lang=js"
export * from "./UserEditMasterStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports